//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resume from "./component/resume.vue";
import managerPassword from "@/pcpage/hr/recruitment/portal/managerPassword";
import profileInfo from "@/pcpage/hr/recruitment/portal/profileInfo";
import commportallogin from "@/pcpage/hr/recruitment/portal/commportallogin";
export default {
  extends: commportallogin,
  name: "information",
  components: {
    resume,
    managerPassword,
    profileInfo,
  },
  data() {
    return {
      tabIndex: 1,
      openResume: true,
      statusImg: {
        true: require("../../../../assets/images/success.png"),
        false: require("../../../../assets/images/error1.png"),
      },
      title: ["", "Profile", "My Resume", "Manage Password"],
      record: {},
      resumeinfo: {}, //简历信息
      showSave: false, //点击按扭后禁用
      isFillProfile: false,
      RCid: '',
      uuid: '',
      appellationList: [],
      suffixList: [],
      genderList: [],
    };
  },
  methods: {
    switchTab(index) {
      this.tabIndex = index;
    },
    addCV() {
      let params = {};
      let uuidApi = "api/api/portalLogin/getPortalResumeId";
      let uuid = "";
      this.axios
        .post(uuidApi, params)
        .then(({ data }) => {
          if (data.code == "1") {
            uuid = data.data.resumeid;
            this.resumeinfo = {
              portalid: this.record.portalid,
              act: "add",
              resumeid: uuid,
              educationlist: [],
              experiencelist: [],
            };
            this.openResume = true;
          }
        })
        .catch((error) => console.log(error));
    },
    /**getPortalUUid() { //获取UUID
            return this.setUUid() + this.setUUid() + this.setUUid() + this.setUUid() + this.setUUid() + this.setUUid();
        },
        setUUid() { //获取4位随机数
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },**/
    discardCV() {
      this.openResume = false;
    },
    async editCV(resumeid) {
      // this.openResume = true;
      let emailUrl = "api/api/portalLogin/getPortalResumeInfo";
      let params = {
        record: {
          resumeid: resumeid,
        },
      };
      await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.resumeinfo = data.data.record;
          }
        })
        .catch((error) => console.log(error));
    },
    async saveCV() {
      if (!this.checkForm3(this.resumeinfo)) {
        //验证表单
        return false;
      }
      this.showSave = true;
      let saveUrl = "api/api/portalLogin/savePortalResumeInfo";
      let params = {
        record: this.resumeinfo,
      };
      await this.axios
        .post(saveUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            this.$msgDailog
              .showMsgBox({
                // title: msg,
                title: "Submit Successfully",
              })
              .then(async (val) => {
                this.showSave = false;
                // this.openResume = false;
                this.getPortalUserInfo();
                if (this.isFillProfile) {
                  this.isFillProfile = false;
                  this.$router.push({
                  path: "/portal/submitResume",
                    query: {
                      RCid: this.RCid,
                      uuid: this.uuid
                    },
                  });
                }
              })
              .catch(() => {
                // ... 点击取消触发事件 已隐藏
              });
          }
        })
        .catch((error) => console.log(error));
    },
    delCV(index, resumeid) {
      console.log("del");
      //删除简历
      this.$msgDailog
        .showMsgBox({
          title: "Are you sure to delete this resume?",
          ifcancel: true,
        })
        .then(async (val) => {
          this.delResumeInfo(index, resumeid); //点击确定触发事件 val:返回文本域内容
        })
        .catch(() => {
          // ... 点击取消触发事件 已隐藏
        });
    },
    delResumeInfo(index, resumeid) {
      //删除简历
      let deletelUrl = "api/api/portalLogin/deleteResumeInfo";
      let params = {
        resumeid: resumeid,
      };
      this.axios
        .post(deletelUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
              return;
            }
            this.record.resumelist.splice(index, 1);
          }
        })
        .catch((error) => console.log(error));
    },
    async getPortalUserInfo() {
      //获取用户信息
      let emailUrl = "api/api/portalLogin/getPortalUserInfo";
      let params = {};
      await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.record = data.data.record;
          }
        })
        .catch((error) => console.log(error));
    },
    async initSelect() {
      let params = [];
      let appellation = {
        showcode: "appellationList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "APPELLATION",
          paras1: "1",
        },
      };
      let suffix = {
        showcode: "suffixList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "SUFFIX",
          paras1: "1",
        },
      };
      let gender = {
        showcode: "genderList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "GENDER",
          paras1: "1",
        },
      };
      params.push(appellation);
      params.push(suffix);
      params.push(gender);
      this.initDropDown(this, params);
    },
  },
  async created() {
    await this.getPortalUserInfo();
    let query = this.$route.query;
    let resumeid;
    if (query.isFillProfile) {
      this.isFillProfile = query.isFillProfile;
      resumeid = query.resumeid;
      this.RCid = query.rcid,
      this.uuid = query.uuid,
      this.tabIndex = '2';
    } else {
      resumeid = this.record.resumelist[0].resumeid;
    }
    await this.editCV(resumeid);
    await this.initSelect();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/information.vue